<template src="./vehiclechecks.html"></template>
<script>
  import { mapState } from "vuex";
  import Axios from "axios";
  var moment = require("moment");
  export default {
    props: ["NewVehicle", "type"],

    filters: {
      date: function (data) {
        var sendDate = "N/A";
        if (data != "" && data != null) {
          sendDate = moment(data).format("DD-MM-YYYY");
        }
        return sendDate;
      },
    },
    data() {
      return {
        ImageEndpoint: Endpoints.Helper.Image + "/",
        VehicleChecks: [],
        fromDate: "",
        toDate: "",
        vrm: "",
        SearchData: false,
        ShowVehicleNotesModel: false,
        VehicleNotes: "",
        ShowVehicleNotesModelHeading: "Notes",
      };
    },
    mounted() {
      setTimeout(() => {
        this.GetVehicleChecksList();
      }, 3000);
    },
    methods: {
      GetVehicleChecksList(type = "") {
        var obj = { token: localStorage.getItem("token") };
        if (type == "search") {
          obj.vrm = this.vrm;
          obj.fromDate = this.fromDate;
          obj.toDate = this.toDate;
        }
        this.SearchData = true;
        if (this.type === "Asset") {
          obj.assetId = this.NewVehicle.id;
        } else {
          obj.vehicleId = this.NewVehicle.id;
        }
        obj.requestFor = this.type;
        this.ShowLoader = true;
        Axios.post(Endpoints.VehicleChecks.VehicleChecksList, obj).then(
          (Response) => {
            this.ShowLoader = false;
            this.SearchData = false;
            if (Response.data.success) {
              this.VehicleChecks = Response.data.FleetCheckSubmit;
              //this.CompanyChecks = Response.data.CompanyChecks;
            }
          }
        );
      },
      ShowVehicleNotes(VehicleCheck, type = "notes") {
        if (VehicleCheck.notes != null && VehicleCheck.notes != "") {
          this.ShowVehicleNotesModel = true;
          this.VehicleNotes = VehicleCheck.notes;
          this.ShowVehicleNotesModelHeading = "Notes";
        }
      },
    },
  };
</script>
<style scoped>
  .vehicle-check-div {
    height: 177px;
    overflow-y: scroll;
    padding-right: 17px;
  }
</style>
